import {
  Headers,
  ResponseErrorBodyDataValidationError,
  ValidationError,
  ValidateErrorCodes
} from '../../types';
import Fingerprint from '../Fingerprint';
import Request from '../Request';
import i18next from 'i18next';

export async function addFingerprintToRequest(request: Request<unknown>) {
  return request.addHeader({
    name: Headers.Fingerprint,
    value: await new Fingerprint().generate()
  });
}

export function errorsByData(
  data: ResponseErrorBodyDataValidationError,
  t: i18next.TFunction
): { [key: string]: any } {
  let errors = {} as { [key: string]: any };
  data.errors.forEach(error => {
    errors[error.field] = t(tByValidationError(error));
  });
  return errors;
}

function tByValidationError(error: ValidationError) {
  switch (error.code) {
    case ValidateErrorCodes.REQUIRED_FIELD:
      return 'errorRequiredField';
    case ValidateErrorCodes.MAX_LENGHT:
      return 'errorMaxLength';
    case ValidateErrorCodes.EMAIL_IN_USE:
      return 'errorEmailInUse';
    case ValidateErrorCodes.INVALID_PHONE:
      return 'errorInvalidPhone';
    case ValidateErrorCodes.INVALID_DATE:
      return 'errorInvalidDate';
    case ValidateErrorCodes.INVALID_VALUE:
      return 'errorInvalidValue';
    default:
      return 'error';
  }
}
